// Selector groups from the identity: one per organization, sorted by name,
// each with its workspaces sorted by name. Ported from ewt's
// workspace-derivation.ts (itself ported from vouchers'); surveys' identity
// already carries workspace names, so no separate workspaces page is joined
// in.
import type { IdentityRs, Role } from "@/api/types";

export interface SelectorWorkspace {
    id: string;
    name: string;
    role: Role;
}
export interface SelectorGroup {
    organization: { id: string; name: string; colorIndex: number };
    workspaces: SelectorWorkspace[];
    canCreateWorkspace: boolean;
    role: Role;
}

export function deriveSelectorGroups(identity: IdentityRs | undefined): SelectorGroup[] {
    if (!identity) return [];
    const byOrg = new Map<string, SelectorWorkspace[]>();
    for (const ws of identity.workspaces) {
        const list = byOrg.get(ws.organizationId) ?? [];
        list.push({ id: ws.id, name: ws.displayName ?? ws.id, role: ws.role });
        byOrg.set(ws.organizationId, list);
    }
    const sorted = [...identity.organizations]
        .map((org) => ({ org, name: org.displayName ?? org.id }))
        .sort((a, b) => a.name.localeCompare(b.name));
    const groups: SelectorGroup[] = [];
    sorted.forEach(({ org, name }, index) => {
        const workspaces = byOrg.get(org.id) ?? [];
        // An unnamed org with no workspaces is one the tenancy sync never
        // named: not licensed for Surveys. Never show its bare id.
        if (workspaces.length === 0 && (!org.grants.canCreateWorkspace || !org.displayName)) return;
        groups.push({
            organization: { id: org.id, name, colorIndex: index },
            workspaces: workspaces.slice().sort((a, b) => a.name.localeCompare(b.name)),
            canCreateWorkspace: org.grants.canCreateWorkspace,
            role: org.role,
        });
    });
    return groups;
}
